import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseTrackReachParams {
  trackId: string;
  date?: Date;
  rangeDays?: number;
}

export const useTrackReach = ({ trackId, date, rangeDays }: UseTrackReachParams) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  const reachQuery = useTRPCQuery(
    trpcMusicAPI.tracks.reach.queryOptions(
      {
        trackId,
        date,
        rangeDays,
        ...shareTokenInput,
      },
      {
        enabled: Boolean(trackId),
      }
    )
  );

  return reachQuery;
};
